import React,{useState,useEffect} from "react";
import {runRawQuery} from "../../../Services/logsServices"
import SqlOutput from "./sqlOutput"
import { checkPermissions } from "../../../Services/User/User";
import { useNavigate } from "react-router-dom";
function Database() {
  let [sqlQuery,setSqlQuery]=useState("");
  let [errorMessage,setErrorMessage]=useState("");
  let [sqlResponse,setSqlResponse]=useState([]);
  let [isLoading,setIsloading]=useState(false);
  const navigate = useNavigate();
  const handleChange = (event) => {
    setSqlQuery(event.target.value);
  };
  useEffect(() => {
  if(!checkPermissions('database_page') || !checkPermissions('developer_navigation')){ 
      navigate('/')
    }
  },[])
  const runSqlQuery=()=>{
    if(sqlQuery.trim()!==""){
      setIsloading(true)
      runRawQuery({"sqlquery":sqlQuery}).then((response)=>{    
        setIsloading(false)
        window.scrollBy(0, 400);
        if(response.status){ 
          response.data.length>0?setSqlResponse(response.data):setErrorMessage('Data not found')
        }else{
          setErrorMessage(response.errorMessage)
          setSqlResponse([])
        }
      }).catch((error)=>{
        setSqlResponse([])
      })
    }   
  }
  return (
    <div>
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Database</h1>
        </div>
        <section className="section">
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="form-group"> 
                           <h5 className="card-title">Write Query To Execute</h5>
                           <textarea className="form-control" onChange={handleChange} rows="8" value={sqlQuery}/> 
                        </div> 
                        <br />
                        <button className="btn btn-primary" onClick={runSqlQuery}  disabled={isLoading?true:false} > 
                       {isLoading?<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>:''}  
                         &nbsp; Execute  
                          </button>
                         
                        <button className="btn btn-primary" onClick={()=>{ setSqlResponse(""); setErrorMessage(""); setSqlQuery(""); }}>Clear</button>
                         <div className="mt-3">
                          <strong >Note: <span className="text-danger">Delete, Truncate, Drop and Update</span> operations should not be performed, It's recommended to use limit query to retrieve data.</strong>
                      </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <h5 className="card-title">Output</h5>
                        <div className="mh" >
                        {
                            sqlResponse.length>0? <SqlOutput data={sqlResponse}/>:errorMessage
                          }
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </section>
      </main>
    </div>
  );
}
export default Database;
